import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../pulsechain_components/Button';
import { Link } from '../../pulsechain_components/Link';
import { routesEnum } from '../../Routes';
import { ClientId } from '../../store/actions/clientActions';

type Props = {
  ethClientStep: 'execution' | 'consensus';
  currentClient: ClientId;
  handleSubmit: () => void;
  updateStep: (nextStep: 'execution' | 'consensus') => void;
};

const SelectClientButtons = ({
  ethClientStep,
  currentClient,
  handleSubmit,
  updateStep,
}: Props) => {
  const { formatMessage } = useIntl();

  if (ethClientStep === 'execution') {
    return (
      <>
        <Link to={routesEnum.acknowledgementPage}>
          <Button
            className="mr10"
            width={100}
            label={formatMessage({ defaultMessage: 'Back' })}
          />
        </Link>
        <Button
          width={300}
          rainbow
          disabled={!currentClient}
          label={formatMessage({ defaultMessage: 'Continue' })}
          onClick={() => updateStep('consensus')}
        />
      </>
    );
  }

  return (
    <>
      <Button
        className="mr10"
        width={100}
        label={formatMessage({ defaultMessage: 'Back' })}
        onClick={() => updateStep('execution')}
      />
      <Button
        width={300}
        rainbow
        disabled={!currentClient}
        label={formatMessage({ defaultMessage: 'Continue' })}
        onClick={() => {
          handleSubmit();
        }}
      />
    </>
  );
};

export default SelectClientButtons;
